var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"meeting-item-wrapper d-flex flex-wrap",attrs:{"href":_vm.meetingItem.url}},[_c('span',{staticClass:"meeting-item"},[_vm._v(_vm._s(_vm.meetingItem.startDate))]),_c('span',{staticClass:"meeting-item"},[_vm._v(_vm._s(_vm.meetingItem.group))]),_c('span',{staticClass:"meeting-item"},[_vm._v(_vm._s(_vm.meetingItem.startTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }